import { SpriteTypes, spriteCategory } from './types/sprite-types'
import { uuid } from '@/libs/src/utils/tools'
import bgConfig from './component-config/bgConfig'
import otherConfig from './component-config/otherConfig'
import poolConfig from './component-config/poolConfig'
import imgV1 from './component-config/imgs'
import formConfig from './component-config/formConfig'
import chartsConfig from './component-config/chartsConfig'
import deviceConfig from './component-config/deviceConfig'

const options = {
    width: 100,
    height: 100,
    lineWidth: 1,
    radio:true,
    imageRatio:true,
    visible:true,
    disableAnchor:true,
}
export default [
    {
        name: '基础组件',
        id: 0,
        list: [
            {
                id: uuid(),
                name: "矩形",
                // image: "images/technology/有水池体.png",
                icon: 'icon-xingzhuang-juxing',
                data: {
                    name: 'rectangle',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "粒子发射器",
                // image: "images/technology/有水池体.png",
                icon: 'icon-duoxilieqipaotu',
                data: {
                    name: 'particle',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "圆形",
                // image: "images/technology/有水池体.png",
                icon: 'icon-yuanxingweixuanzhong',
                data: {
                    name: 'circle',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "三角形",
                // image: "images/technology/有水池体.png",
                icon: 'icon-xingzhuang-sanjiaoxing',
                data: {
                    name: 'triangle',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "菱形",
                // image: "images/technology/有水池体.png",
                icon: 'icon-pinghangsibianxing',
                data: {
                    name: 'diamond',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "五边形",
                // image: "images/technology/有水池体.png",
                icon: 'icon-pentagon',
                data: {
                    name: 'pentagon',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "五角星",
                // image: "images/technology/有水池体.png",
                icon: 'icon-kongwujiaoxing',
                data: {
                    name: 'pentagram',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "六边形",
                // image: "images/technology/有水池体.png",
                icon: 'icon-hexagon',
                data: {
                    name: 'hexagon',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "左箭头",
                // image: "images/technology/有水池体.png",
                icon: 'icon-left',
                data: {
                    name: 'leftArrow',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "右箭头",
                // image: "images/technology/有水池体.png",
                icon: 'icon-right',
                data: {
                    name: 'rightArrow',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "消息框",
                // image: "images/technology/有水池体.png",
                icon: 'icon-xiaoxi',
                data: {
                    name: 'message',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "云",
                // image: "images/technology/有水池体.png",
                icon: 'icon-yun_o',
                data: {
                    name: 'cloud',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "文件",
                // image: "images/technology/有水池体.png",
                icon: 'icon-wenjianjia_o',
                data: {
                    name: 'file',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "立方体",
                // image: "images/technology/有水池体.png",
                icon: 'icon-cubelifangti',
                data: {
                    name: 'cube',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "人",
                // image: "images/technology/有水池体.png",
                icon: 'icon-gerentouxiang_o',
                data: {
                    name: 'people',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "网页",
                // image: "images/technology/有水池体.png",
                icon: 'icon-program-full',
                data: {
                    name: 'iframe',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "音视频",
                // image: "images/technology/有水池体.png",
                icon: 'icon-yinshipinhuichuan',
                data: {
                    name: 'video',
                    ...options,
                    text: "VIDEO",
                    video: 'images/default/video.mp4',
                    autoPlay: false,
                },
            },
            {
                id: uuid(),
                name: "gif 动画",
                // image: "images/technology/有水池体.png",
                icon: 'icon-GIF',
                data: {
                    name: 'gif',
                    ...options,
                },
            },
            {
                id: uuid(),
                name: "文字",
                // image: "images/technology/有水池体.png",
                icon: 'icon-wenzi',
                data: {
                    name: 'rectangle',
                    width:100,
                    height:30,
                    lineWidth:0,
                    text: "一段文本",
                },
            },
            {
                id: uuid(),
                name: "svg path",
                // image: "images/technology/有水池体.png",
                icon: 'icon-SVG',
                data: {
                    name: 'svgPath',
                    ...options,
                },
            }
        ]
    },
    {
        name: '设备控制',
        id: uuid(),
        list: deviceConfig
    },
    {
        name: '表单',
        id: uuid(),
        list: formConfig
    },
    {
        name: '水池',
        id:uuid(),
        list: poolConfig
    },
    {
        name: '图形（1）',
        id: uuid(),
        list: imgV1
    },
    {
        name: '其他',
        id: uuid(),
        list: otherConfig
    },
    {
        name: '背景',
        id: uuid(),
        list: bgConfig
    },{
        name:'图表',
        id:uuid(),
        list:chartsConfig
    }
]